/**
 * Types for DownloadRedirectView component
 */

export const CONTENT_TYPES = { File: 'File', Image: 'Image' } as const;

export interface FileField {
  download: string;
  'content-type': string;
}

export interface ImageField {
  download: string;
}

export interface DownloadContent {
  '@type'?: typeof CONTENT_TYPES.File | typeof CONTENT_TYPES.Image;
  '@id'?: string;
  file?: FileField;
  image?: ImageField;
  link?: string;
}

export interface RouteLoc {
  pathname: string;
  search: string;
}

export interface PrevRouteState {
  prevRoute: {
    prev: RouteLoc | null;
  };
}

export interface VoltoSettings {
  apiPath?: string;
}

export interface DownloadRedirectViewProps {
  token?: string;
  content: DownloadContent;
}
